import { forwardRef, type FC, type PropsWithChildren } from 'react'
import { Dropdown } from 'react-bootstrap'
import { Button, type ButtonProps } from '../../../components/Button/Button'
import { PortalDropdownMenu } from '../shared/PortalDropdownMenu'

interface BookingActionMenuProps {
  ariaLabel: string
}

const KebabToggle = forwardRef<HTMLButtonElement, ButtonProps>(({ children, ...rest }, ref) => (
  <Button ref={ref} {...rest} type='button' variant='borderlessGrayButton' className='p-2'>
    {children}
  </Button>
))

export const BookingActionMenu: FC<PropsWithChildren<BookingActionMenuProps>> = ({ ariaLabel, children }) => (
  <Dropdown align='end'>
    <Dropdown.Toggle as={KebabToggle} aria-label={ariaLabel}>
      <i className='bi bi-three-dots-vertical' />
    </Dropdown.Toggle>
    <Dropdown.Menu as={PortalDropdownMenu} popperConfig={{ strategy: 'fixed' }}>
      {children}
    </Dropdown.Menu>
  </Dropdown>
)
